export default __webpack_public_path__ + "static/media/guide-to-allowable-otc-expenses.31a2d5c4.svg";